import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';
import { data } from './data';
import Start from './pages/Start';
import Bearing from './pages/Bearing';
import BearingSearch from './pages/BearingSearch';
import Results from './pages/Results';
import BearingDesign from './pages/BearingDesign';
import React from 'react';
import { PageData } from './types/types';
import BearingResults from './pages/BearingResults';

const routes: Array<RouteObject> = [
	{
		path: '/',
		element: <Navigate to={data.start.name} replace />,
	},
	{
		path: data.start.name,
		element: <Start />,
		loader: (): PageData => data.start,
	},
	{
		path: data.bearing.name,
		element: <Bearing />,
		loader: (): PageData => data.bearing,
	},
	{
		path: data.bearingSearch.name,
		element: <BearingSearch />,
		loader: (): PageData => data.bearingSearch,
	},
	{
		path: `${ data.bearingInfo.name }/:partNumber`,
		element: <BearingResults />,
		loader: ( { params } ): PageData => ( {
			...data.bearingInfo,
			partNumber: params.partNumber,
		} ),
	},
	{
		path: `${ data.quote.name }`,
		element: <Results />,
		loader: (): PageData => data.quote,
	},
	{
		path: `${ data.engineeringTools.name }`,
		element: <Results />,
		loader: (): PageData => data.engineeringTools,
	},
	{
		path: `${ data.troubleshoot.name }`,
		element: <Results />,
		loader: (): PageData => data.troubleshoot,
	},
	{
		path: data.bearingSupport.name,
		element: <Results />,
		loader: (): PageData => data.bearingSupport,
	},
	{
		path: `${ data.bearingDesign.name }`,
		element: <BearingDesign />,
		loader: (): PageData => data.bearingDesign,
	},
	{
		path: `${ data.individualDesign.name }`,
		element: <Results />,
		loader: (): PageData => data.individualDesign,
	},
	{
		path: `${ data.systemDesign.name }`,
		element: <Results />,
		loader: (): PageData => data.systemDesign,
	},
	{
		path: `${ data.otherDesign.name }`,
		element: <Results />,
		loader: (): PageData => data.otherDesign,
	},
];

const options = {
	basename: '/guided-help',
};

const router = createBrowserRouter( routes, options );

export default router;
